(() => {
// Short table-of-contents labels from the supplied editorial reference.
const guideTocLabels = {
  "room-and-installation-location": {
    "quick-answer": "The short answer",
    "measure": "Measure the room",
    "placement-comparison": "Compare fan positions",
    "size": "Match fan size",
    "location": "Choose the location",
    "ceiling": "Read the ceiling",
    "outdoor": "Indoor or outdoor",
    "mistakes": "Common mistakes",
    "faq": "Questions"
  },
  "choose-the-right-ceiling-fan-size": {
    "quick-answer": "The short answer",
    "measure": "Measure correctly",
    "chart": "Fan size chart",
    "airflow": "Size vs. airflow",
    "shape": "Room shape",
    "room": "Room-by-room",
    "product": "301L sizes",
    "faq": "Questions"
  },
  "match-the-fan-to-your-home-style": {
    "quick-answer": "The short answer",
    "method": "A simple method",
    "blend": "Blend or statement",
    "finish": "Choose a finish",
    "styles": "Style map",
    "light": "Fan with light",
    "mistakes": "Common mistakes",
    "faq": "Questions"
  }
};
const initializeGuideToc = (root) => {
  const content = root.querySelector('[data-guide-content]');
  const toc = root.querySelector('[data-guide-toc]');
  if (!content || !toc) return;

  toc.replaceChildren();
  toc.hidden = false;
  const labels = guideTocLabels[root.dataset.guideHandle] || {};
  const headings = Array.from(content.querySelectorAll('h2')).filter((heading) => heading.textContent?.trim());
  if (headings.length < 2) {
    toc.hidden = true;
    return;
  }

  const usedIds = new Set();
  for (const [index, heading] of headings.entries()) {
    const section = heading.closest('section[id]');
    let target = heading.id ? heading : section || heading;
    let id = target.id || `guide-section-${index + 1}`;

    const existingTarget = document.getElementById(id);
    if (usedIds.has(id) || (existingTarget && existingTarget !== target)) {
      target = heading;
      id = `${id}-${index + 1}`;
      while (usedIds.has(id) || document.getElementById(id)) {
        id = `${id}-${index + 1}`;
      }
    }

    if (!target.id) target.id = id;
    usedIds.add(id);

    const link = document.createElement('a');
    link.href = `#${id}`;
    link.textContent = labels[id] || heading.textContent.trim();
    toc.append(link);
  }
};

const initializeGuideAssets = (root) => {
  const mapElement = root.querySelector('script[data-guide-asset-map]');
  if (!mapElement) return;

  let assetMap;
  try {
    assetMap = JSON.parse(mapElement.textContent || '{}');
  } catch (_error) {
    return;
  }

  root.querySelectorAll('[data-guide-content] img[src]').forEach((image) => {
    const source = image.getAttribute('src')?.replace(/^\.\//, '');
    if (source && assetMap[source]) image.setAttribute('src', assetMap[source]);
  });
};

document.querySelectorAll('[data-xcwiie-guide]').forEach((root) => {
  initializeGuideAssets(root);
  initializeGuideToc(root);
});

document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('[data-xcwiie-guide]').forEach((root) => { initializeGuideAssets(root); initializeGuideToc(root); });
});

})();
